/**
 * Facebook Pixel Analytics Plugin
 * 
 * Isolated plugin responsible solely for Meta/Facebook Pixel browser events.
 * Fully decoupled from TikTok, GTM, and application UI components.
 */

import { AnalyticsPlugin, AnalyticsEventPayload } from '../types';

export class FacebookPlugin implements AnalyticsPlugin {
  readonly name = 'facebook';
  private maxRetries = 3;

  isReady(): boolean {
    return typeof window !== 'undefined' && typeof window.fbq === 'function';
  }

  async track(eventName: string, payload: AnalyticsEventPayload): Promise<void> {
    if (typeof window === 'undefined') return;

    let attempts = 0;
    const execute = (): Promise<void> => {
      return new Promise((resolve) => {
        const attemptTrack = () => {
          if (this.isReady()) {
            window.fbq('track', eventName, payload);
            resolve();
          } else if (attempts < this.maxRetries) {
            attempts++;
            setTimeout(attemptTrack, 100);
          } else {
            // FB Pixel not loaded or not configured — resolve gracefully
            resolve();
          }
        };
        attemptTrack();
      });
    };

    await execute();
  }
}
